import { createSlice } from "@reduxjs/toolkit";
import { Activity } from "store/activities/types";
import { getActivity, getWorkspaceActivity } from "./actions";

export type ActivitiesState = {
  error: any;
  loading: boolean;
  list: Activity[];
};

const initialState: ActivitiesState = {
  error: false,
  loading: false,
  list: [],
};

export const activitiesSlice = createSlice({
  name: "activities",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //GET ACTIVITY
    builder.addCase(getActivity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getActivity.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getActivity.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.list = action.payload.data;
    });

    //GET WORKSPACE ACTIVITY
    builder.addCase(getWorkspaceActivity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getWorkspaceActivity.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getWorkspaceActivity.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.list = action.payload.data;
    });
  },
});

export default activitiesSlice.reducer;
